import React, { useState, useEffect, memo } from "react";
import { useNavigate } from "react-router-dom";
import { rentalCar } from "api/car";
import { getCookie, kickUser } from "components/helper/cookies";
import CardTemplate from "components/template/card";
import { toast, ToastContainer } from "react-toastify";
import { toastStyle } from "components/helper";
import "react-toastify/dist/ReactToastify.css";
import { createAccess } from "components/helper";

function RentalCar({ searchName, handleSearchshow, handleLoader }) {
  const [data, setData] = useState([]);
  const [total_entries, setTotal_entries] = useState(0);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState({ query: "" });
  const [page, setPage] = useState(1);
  const perPage = 24;
  let navigate = useNavigate();
  const path = window.location.pathname.split("/")[1];
  let controller = new AbortController();
  useEffect(() => {
    handleSearchshow(true);
    handleLoader(true);
    handleSearch({ target: { value: searchName } });
  }, [searchName]);
  useEffect(() => {
    handleSearch({ target: { value: "" } });
  }, [path]);
  useEffect(() => {
    handleLoader(true);
    setLoading(true);
    const params = {
      page,
      perPage,
    };
    rentalCar(getCookie("auth_token"), params, search, controller)
      .then(({ data, total_entries }) => {
        setData(data);
        setTotal_entries(total_entries);
        setLoading(false);
        handleLoader(false);
      })
      .catch((err) => {
        if (err[0] === 403 || err[0] === 401) {
          toast.error(err[1].message, toastStyle);
          kickUser();
        }
      });
    return () => {
      controller.abort();
    };
  }, [page, search]);

  const handleSearch = (e) => {
    const { value } = e.target;
    setSearch((preState) => ({ ...preState, query: value }));
  };
  const handlePageChange = (page) => {
    setPage(page);
    setLoading(true);
    handleLoader(true);
  };
  const handleCreate = () => {
    navigate("/rentalcar/new");
  };

  const rentalProps = {
    data,
    total_entries,
    loading,
    title: "Rental Car",
    handleCreate,
    createAction: createAccess("rentals"),
    menu: "rentals",
    handlePageChange,
    perPage,
    page,
  };
  return (
    <>
      <CardTemplate {...rentalProps} key={"rental"} />
      <ToastContainer style={{ zIndex: 999999 }} />
    </>
  );
}
export default memo(RentalCar);
